import React from 'react';
import styled from 'styled-components';
import { RFC } from 'state/StateTypes';
import { pluralize } from 'utils';

const Placeholder: RFC<{ content: string }> = ({ content }) => <Container>There are no {pluralize(content)} to display!</Container>;

export default Placeholder;

const Container = styled.div`
   margin: 0 auto;
   padding: 1em;
   text-align: center;
   background-color: ${({ theme }) => theme.secondaryWhite};
   border: 1px solid ${({ theme }) => theme.primaryGrey};
   border-radius: 5px;
   font-weight: bold;
   font-size: 1.5em;
`;
